module.exports = __webpack_public_path__ + "static/laptop-79aa626cfe0e130af0d36245fbb1f3bf.png";